import { render, staticRenderFns } from "./ReservationItem.vue?vue&type=template&id=b9fffd2e"
import script from "./ReservationItem.vue?vue&type=script&lang=js"
export * from "./ReservationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports